<script>
export default {
  name: 'ChatbotClickWatcher',
  data() {
    return {
      chatbotButtonElement: null,
      domObserver: null,
      boundHandleButtonClick: null,
    };
  },
  created() {
    // bind event handler
    this.boundHandleButtonClick = this.handleButtonClick.bind(this);
  },
  mounted() {
    this.initButtonDetection();
  },
  beforeDestroy() {
    if (this.domObserver) {
      this.domObserver.disconnect();
      // console.log('ChatbotClickWatcher DOM observer disconnected');
    }
    if (this.chatbotButtonElement && this.boundHandleButtonClick) {
      this.chatbotButtonElement.removeEventListener('click', this.boundHandleButtonClick);
      // console.log('ChatbotClickWatcher click listener removed from chatbot-button');
    }
  },
  methods: {
    initButtonDetection() {
      const buttonSelector = '.dr-chatbot-button';
      const buttonElement = document.querySelector(buttonSelector);
      if (buttonElement) {
        this.buttonFound(buttonElement);
      } else {
        // console.log('ChatbotClickWatcher chatbot-button not found immediately. Observing DOM...');
        this.domObserver = new MutationObserver((mutationsList, observer) => {
          // Iterate over mutations to find the button
          mutationsList.forEach((mutation) => {
            if (mutation.type === 'childList') {
              // Check if the specific button is now available
              const targetButton = document.querySelector(buttonSelector);
              if (targetButton) {
                // console.log('ChatbotClickWatcher: chatbot-button found via MutationObserver.');
                this.buttonFound(targetButton);
                observer.disconnect(); // Stop observing once found
                this.domObserver = null;
              }
            }
          });
        });
        this.domObserver.observe(document.documentElement, {
          childList: true,
          subtree: true,
        });
      }
    },
    buttonFound(element) {
      this.chatbotButtonElement = element;
      // console.log('ChatbotClickWatcher chatbot-button element found:', this.chatbotButtonElement);
      // Add click listener to the button
      if (this.boundHandleButtonClick) {
        this.chatbotButtonElement.addEventListener('click', this.boundHandleButtonClick);
        // console.log('ChatbotClickWatcher Click listener attached to chatbot-button.');
      }
    },
    handleButtonClick() {
      // console.log('ChatbotClickWatcher chatbot-button was clicked!');
      this.$emit('chatbot-button-clicked');
    },
  },
  render() {
    return null; // renderless component
  },
};
</script>
